import { Button, Col, Input, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

function ShowUser(props) {

    return (
        <>
            <Col span={1} offset={2}>
                <input type="radio" name="user" onClick={() => props.onSelect(props.association)} />
            </Col>
            <Col span={8}>
                <Input bordered={false} value={props.email} />
            </Col>
            <Col span={7}>
                <Input bordered={false} value={props.association} />
            </Col>
            <Col span={4}>
                <Popconfirm
                    title={props.email + " (" + props.association + ") wirklich löschen?"}
                    okText="Löschen"
                    cancelText="Abbrechen"
                    okButtonProps={{ type: "danger" }}
                    onConfirm={async () => props.onDelete(props.id)}
                >
                    <Button
                        icon={<DeleteOutlined />}
                    >
                        Löschen
                    </Button>
                </Popconfirm>
            </Col>
            <Col span={2} />
        </>
    )
};

export default ShowUser;